/** Octahedral cloud atlas: avoids latitude rows expanding into visible bands at
 * the poles. Shared by the sky, flight volume and every cloud-shadow consumer.
 * Encoding follows the nonzero-sign convention in Cigolle et al., JCGT 2014:
 * https://jcgt.org/published/0003/02/01/
 * +Y is the centre; the -Y hemisphere folds around the square's boundary. */
export const CLOUD_MAP_SIZE = 1024;
export const CLOUD_MAPPING_GLSL = /* glsl */ `
vec2 cloudSign(vec2 v) { return vec2(v.x >= 0.0 ? 1.0 : -1.0, v.y >= 0.0 ? 1.0 : -1.0); }
vec2 cloudUv(vec3 d) {
  d /= abs(d.x) + abs(d.y) + abs(d.z);
  vec2 p = d.xz;
  if (d.y < 0.0) p = (1.0 - abs(p.yx)) * cloudSign(p);
  return p * 0.5 + 0.5;
}
vec3 cloudDirection(vec2 uv) {
  vec2 p = uv * 2.0 - 1.0;
  vec3 d = vec3(p.x, 1.0 - abs(p.x) - abs(p.y), p.y);
  if (d.y < 0.0) d.xz = (1.0 - abs(d.zx)) * cloudSign(d.xz);
  return normalize(d);
}
`;
